import { EditOutlined } from "@ant-design/icons";
import { KeyValuePairs } from "@cloudscape-design/components";
import { Card } from "antd";
import IncredableButton from "../../components/button";
import { SectionType } from "../../redux/api/section/types";
import { ProviderProfileRecordType } from "./section-data";
import AddEditProviderProfileSection from "./add-edit-provider-profile-section";
import { useCallback, useEffect, useState } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";

export default function SectionCard({
  sectionMeta,
  sectionData,
}: {
  sectionMeta: SectionType;
  sectionData: ProviderProfileRecordType[];
}) {
  const [isOpen, setIsOpen] = useState(false);
  const sectionAttributes = Array.isArray(sectionMeta.attributes)
    ? sectionMeta.attributes
    : Object.values(sectionMeta.attributes || {});
  const sectionRecord = sectionData[1];
  const formattedSectionFields = sectionAttributes.map((attr: any) => ({
    label: attr.name,
    value:
      sectionRecord?.[attr.id] &&
      sectionRecord?.[attr.id] !== "null" &&
      sectionRecord?.[attr.id] !== ""
        ? sectionRecord?.[attr.id]
        : "N/A",
  }));

  const toggleDrawer = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, [setIsOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <>
      <Card
        title={
          <span style={{ fontSize: "18px", textTransform: "capitalize" }}>
            {sectionMeta?.name}
          </span>
        }
        extra={
          <IncredableButton
            type="primary"
            icon={<EditOutlined />}
            iconPosition="start"
            onClick={() => toggleDrawer()}
          >
            Edit
          </IncredableButton>
        }
      >
        <KeyValuePairs
          id="keyvaluepair"
          columns={3}
          items={formattedSectionFields}
        />
      </Card>
      {isOpen && (
        <Drawer
          open={isOpen}
          onClose={toggleDrawer}
          direction="right"
          size="90vw"
        >
          <AddEditProviderProfileSection
            recordId={sectionRecord?.recordId}
            sectionData={sectionMeta}
            toggleDrawer={toggleDrawer}
          />
        </Drawer>
      )}
    </>
  );
}
